import { withMutation } from '../../HOC/common';
import * as gazetteerService from 'services/gazetters';
import { showNotification } from 'helpers';

/**
 * mutation function that calls the service
 * @param {object} params
 * @param {string} params.gazetterName - name of the file to save
 * @param {import('services/gazetters').GazetteerOperation[]} params.values - gazetteer operations
 * @returns {Promise<string>} new version of the file from the server
 */
const saveContentMutationFn = async ({ gazetterName, values }) => {
    const response = await gazetteerService.saveGazetterPartially(gazetterName, values);
    return response.data;
};


/**
 * hoc that provides gazetteer content-saving functionality to a component
 */
export const withGazetterContentSave = withMutation({
    mutationFn: saveContentMutationFn,
    mutationOptions: {
        onSuccess: () => {
            showNotification('Gazetteer saved successfully!');
        },
        onError: (error) => {
            showNotification(
                `Failed to save gazetteer. ${error.message || ''}`,
                'error',
            );
        },
    },
    mapMutationToProps: (mutateAsync, { isLoading, isSuccess, data }) => ({
        saveContentMutation: mutateAsync,
        isSavingContent: isLoading,
        newVersion: data ? data.data : null,
        isSaveContentSuccess: isSuccess,
    }),
});



// WEBPACK FOOTER //
// ./app/components/Gazetteers/HOC.jsx